import React from "react";
import Sidebar from "../Sidebar/Sidebar";
import { Box, Stack, MenuItem } from "@mui/material";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import LocalstorageHelper from "../../LocalStorageHelper/LocalstorageHelper";
import { Redirect } from "react-router-dom";
import Task from "@mui/icons-material/Task";
import ReportNavigation from "../../Components/ReportNavigation/ReportNavigation";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import ReportLoadingDialog from "../../Components/ReportLoadingDialog";
toast.configure();

const StkTransferRegister = () => {
  //GET THE TOKEN FROM HELPER CLASS

  const userToken = LocalstorageHelper.GetUserToken();

  const redirectToLoginPage = () => {
    if (!userToken) {
      return <Redirect exact to="/sparepartsLogin" />;
    }
  };
  const date = new Date();
  const [fromdate, setfromdate] = useState(null);
  const [todate, settodate] = useState(date);
  const [pdfStream, setPdfStream] = useState(null);
  const [reportTypeValue, setReportTypeValue] = useState(1);
  const reportType = [
    {
      name: "Transfered Stock",
      value: 1,
    },
    {
      name: "Received Stock",
      value: 2,
    },
  ];
  const [reportSumType, setReportSumType] = useState(1);
  const reportTypeSum = [
    {
      name: "Summary",
      value: 1,
    },
    {
      name: "Detail",
      value: 2,
    },
  ];
  const [viewType, setviewType] = useState("BOTH");
  const viewTypeOpts = [
    {
      name: "ALL",
      value: "BOTH",
    },
    {
      name: "RECEIVE",
      value: "RECEIVE",
    },
    {
      name: "ISSUE",
      value: "ISSUE",
    },
  ];
  const [genrating, setgenrating] = useState(false);
  const [reportText, setReportText] = useState({
    title: "",
    subtitle: "",
  });
  //fetch state data
  async function getfromdatedata() {
    try {
      const response = await fetch("/reports/fromdate", {
        method: "GET",
        headers: { sptoken: userToken },
      });
      const jsonData = await response.json();
      setfromdate(jsonData.fromdate);
    } catch (err) {
      console.error(err.message);
    }
  }
  useEffect(() => {
    getfromdatedata();
  }, []);

  //report sum
  const handleReport = async (e) => {
    e.preventDefault();
    setReportText({
      title: "Generating Report",
      subtitle: "Preparing report. Please wait…",
    });

    setgenrating(true);
    try {
      if (fromdate === null) {
        toast.error("Please Select A valid Date!");
      } else {
        const body = { fromdate, todate, reportTypeValue };
        const options = {
          headers: {
            "Content-Type": "application/json",
            sptoken: userToken,
          },
          method: "POST",
          body: JSON.stringify(body),
        };
        const response = await fetch("/reports/stktransferreg", options)
          .then((response) => response.blob())
          .then((pdfBlob) => {
            const pdfUrl = URL.createObjectURL(pdfBlob);
            setPdfStream(pdfUrl);
          })
          .catch((error) => console.error(error));
        setgenrating(false);
      }
    } catch (err) {
      setgenrating(false);
      console.log(err.message);
    }
  };
  const printexcel = async (e) => {
    e.preventDefault();
    if (fromdate === null) {
      return toast.error("Please Select The From Date!!");
    }
    setReportText({
      title: "Generating Report",
      subtitle: "Preparing report. Please wait…",
    });

    setgenrating(true);
    try {
      //partyarray = parray.map((opt) => opt.subledgerid);
      const body = { fromdate, todate, reportTypeValue };
      const data = await fetch("/stktransferreg/download/excel", {
        method: "POST",
        headers: {
          sptoken: userToken,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });

      const blob = await data.blob();

      // Create a download link
      const downloadLink = document.createElement("a");
      downloadLink.href = window.URL.createObjectURL(blob);
      if (reportTypeValue === 1) {
        downloadLink.download = "transferdstock.xlsx";
      } else {
        downloadLink.download = "receivedstock.xlsx";
      }

      // Append the link to the body
      document.body.appendChild(downloadLink);

      // Trigger the click event to start the download
      downloadLink.click();

      // Remove the link from the body
      document.body.removeChild(downloadLink);
      setgenrating(false);
    } catch (error) {
      setgenrating(false);
      console.log(error.message);
    }
  };

  //report Details
  const handleReportD = async (e) => {
    e.preventDefault();
    setReportText({
      title: "Generating Report",
      subtitle: "Preparing report. Please wait…",
    });

    setgenrating(true);
    try {
      if (fromdate === null) {
        toast.error("Please Select A valid Date!");
      } else {
        const body = { fromdate, todate, viewType: viewType };
        const options = {
          headers: {
            "Content-Type": "application/json",
            sptoken: userToken,
          },
          method: "POST",
          body: JSON.stringify(body),
        };
        const response = await fetch("/reports/stktransferreg/dtls", options)
          .then((response) => response.blob())
          .then((pdfBlob) => {
            const pdfUrl = URL.createObjectURL(pdfBlob);
            setPdfStream(pdfUrl);
          })
          .catch((error) => console.error(error));
        setgenrating(false);
      }
    } catch (err) {
      setgenrating(false);
      console.log(err.message);
    }
  };
  const printexcelD = async (e) => {
    e.preventDefault();
    if (fromdate === null) {
      return toast.error("Please Select The From Date!!");
    }
    setReportText({
      title: "Generating Report",
      subtitle: "Preparing report. Please wait…",
    });

    setgenrating(true);
    try {
      //partyarray = parray.map((opt) => opt.subledgerid);
      const body = { fromdate, todate, viewType: viewType };
      const data = await fetch("/stktransferreg/dtls/download/excel", {
        method: "POST",
        headers: {
          sptoken: userToken,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });

      const blob = await data.blob();

      // Create a download link
      const downloadLink = document.createElement("a");
      downloadLink.href = window.URL.createObjectURL(blob);
      if (reportTypeValue === 1) {
        downloadLink.download = "transferdstock.xlsx";
      } else {
        downloadLink.download = "receivedstock.xlsx";
      }

      // Append the link to the body
      document.body.appendChild(downloadLink);

      // Trigger the click event to start the download
      downloadLink.click();

      // Remove the link from the body
      document.body.removeChild(downloadLink);
      setgenrating(false);
    } catch (error) {
      setgenrating(false);
      console.log(error.message);
    }
  };
  return (
    <>
      <ReportLoadingDialog
        open={genrating}
        title={reportText.title}
        subtitle={reportText.subtitle}
      />
      <Sidebar
        Title={"STOCK TRANSFER REGISTER"}
        expandedPanel={"panel3"}
        children={
          <Box
            component="form"
            sx={{
              width: "100%",
            }}
            //onSubmit={handleSubmit}
            autoComplete="off"
          >
            <Box
              sx={{
                marginTop: "4rem",
                display: "flex",
                flexWrap: "wrap",
                columnGap: "20px",
                justifyContent: "center",
              }}
            >
              <TextField
                id="Type"
                name="Type"
                required
                select
                label="ReportType"
                value={reportSumType}
                onChange={(e) => setReportSumType(e.target.value)}
                variant="outlined"
                sx={{
                  width: "250px",
                }}
                size="small"
              >
                {reportTypeSum.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.name}
                  </MenuItem>
                ))}
              </TextField>
              {reportSumType === 1 && (
                <>
                  <TextField
                    id="Type"
                    name="Type"
                    required
                    select
                    label="Type"
                    value={reportTypeValue}
                    onChange={(e) => setReportTypeValue(e.target.value)}
                    variant="outlined"
                    sx={{
                      width: "250px",
                    }}
                    size="small"
                  >
                    {reportType.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.name}
                      </MenuItem>
                    ))}
                  </TextField>
                </>
              )}
              {reportSumType === 2 && (
                <>
                  <TextField
                    id="Type"
                    name="ViewType"
                    required
                    select
                    label="Type"
                    value={viewType}
                    onChange={(e) => setviewType(e.target.value)}
                    variant="outlined"
                    sx={{
                      width: "250px",
                    }}
                    size="small"
                  >
                    {viewTypeOpts.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.name}
                      </MenuItem>
                    ))}
                  </TextField>
                </>
              )}
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="From Date"
                  inputFormat="DD/MM/YYYY"
                  value={fromdate}
                  onChange={(newValue) => {
                    setfromdate(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      required
                      {...params}
                      sx={{
                        width: "20%",
                      }}
                      size="small"
                    />
                  )}
                />
              </LocalizationProvider>

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="To Date"
                  inputFormat="DD/MM/YYYY"
                  value={todate}
                  onChange={(newValue) => {
                    settodate(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      required
                      {...params}
                      sx={{
                        width: "20%",
                      }}
                      size="small"
                    />
                  )}
                />
              </LocalizationProvider>
              {reportSumType === 1 && (
                <>
                  <Button
                    type="submit"
                    onClick={handleReport}
                    variant="contained"
                    component="label"
                    size="large"
                    sx={{ boxShadow: "2px 2px 6px  #404142" }}
                    endIcon={<Task />}
                  >
                    Show Report Sum
                  </Button>
                  <Button
                    onClick={printexcel}
                    size="small"
                    variant="contained"
                    color="success"
                    //endIcon={<PrintIcon />}
                  >
                    Excel Sum
                  </Button>
                </>
              )}
              {reportSumType === 2 && (
                <>
                  <Button
                    type="submit"
                    onClick={handleReportD}
                    variant="contained"
                    component="label"
                    size="large"
                    sx={{ boxShadow: "2px 2px 6px  #404142" }}
                    endIcon={<Task />}
                  >
                    Show Report Detail
                  </Button>
                  <Button
                    onClick={printexcelD}
                    size="small"
                    variant="contained"
                    color="success"
                    //endIcon={<PrintIcon />}
                  >
                    Excel Detail
                  </Button>
                </>
              )}
            </Box>
            {/* {pdfStream && (
            <ReportNavigation
              onDownload={handleDownload}
              reportName={"GOVT GST"}
            />
          )} */}
            <Box sx={{ backgroundColor: "white", mt: 5 }}>
              {pdfStream && (
                <iframe
                  src={pdfStream}
                  width="100%"
                  height="680px"
                  title="report"
                ></iframe>
              )}
            </Box>
          </Box>
        }
      />
      {/* <FooterElement /> */}
      {redirectToLoginPage()}
    </>
  );
};

export default StkTransferRegister;
